export interface ICategory {
    englishTitle: string;
    frenchTitle: string;
    id: number;
}
export interface ITenant {
    //GetLocatairesByBuildingId?buildingId=22
    id: number;
    tenantId: number;
    buildingId: number;
    categoryId: number;
    suites: string;
    title: string;
}
export interface IContact {
    //GetContactsByBuildingId?buildingId
    id: number;
    userId: number;
    name: string;
    categoryId: number;
    buildingId: number;
    positionFrench: string;
    positionEnglish: string;
    phoneFrench: string;
    phoneEnglish: string;
    emailFrench: string;
    emailEnglish: string;
}
export interface IPhoto {
    buildingId: number;
    id: number;
    repositoryPage: number;
    urlFrenchHorizontal: string;
    urlEnglishHorizontal: string;
    urlFrenchVertical: string;
    urlEnglishVertical: string;
}
export interface IBuilding {
    id: number;
    name: string;
    address: string;
    region: string;
    country: string;
    postalCode: string;
}
export type BuildingId = {
    id: string;
};
export enum ERepositoryPage {
    logo = 0,
    hero = 1,
    information = 2,
    durability = 3,
    certification = 4
}
